import axios from 'axios';
import type { AxiosError } from 'axios';
import applyCaseMiddleware from 'axios-case-converter';

const baseApiUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
const csrfCookieName = '_user_csrf_cloud';

export const appAxios = applyCaseMiddleware(
  axios.create({
    baseURL: baseApiUrl,
    xsrfCookieName: csrfCookieName,
    xsrfHeaderName: 'X-CSRF-Token',
    withCredentials: true,
    withXSRFToken: true,
  }),
  {
    preservedKeys: ['g-recaptcha-response'],
    ignoreHeaders: true,
  }
);

export const isAxiosError = (error: unknown): error is AxiosError => {
  return axios.isAxiosError(error);
};

appAxios.interceptors.request.use(async (config) => {
  const token = document.cookie
    .split(';')
    .find((cookie) => cookie.startsWith(`${csrfCookieName}=`));
  if (token) {
    config.headers['X-CSRF-Token'] = token.split('=')[1];
    return config;
  } else {
    await axios.get(`${baseApiUrl}/token`, { withCredentials: true });
    return config;
  }
});
